import React, { useState, useEffect, useRef } from "react";
import { signupToBlog, createClient } from "../../../lib/helpers";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Hidden, Button, TextField, Checkbox, Icon } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import SanityImage from "gatsby-plugin-sanity-image";
import emailIcon from "./subButton.svg";
import errorIcon from "./errorIcon.svg";
import * as styles from "../../sidebarComponents/sidebar.module.css";
import subscribed from "../../sidebarComponents/img/subscribed.svg";

import { useStaticQuery, graphql } from "gatsby";
import { isValid } from "date-fns";
import { withStyles } from '@material-ui/core/styles';
import ReusableCheckbox from "../../landingPageComponents/blocks/reusableCheckbox";
import { emailCaptureSubmissionLogging } from "../../../lib/helpers";


const checkBoxStyles = theme => ({
  root: {
    display: 'inline-block',
    width: '47px',
    padding: '0 !important',
    verticalAlign: 'top',
    '&$checked': {
      color: '#3D70B2',
    },
    '& .MuiIconButton-label': {
      alignItems: 'flex-start',
      justifyContent: 'flex-start'
    },
  },

  checked: {},
});

const iconStyles = theme => ({
  root: {
  }
});

const CustomCheckbox = withStyles(checkBoxStyles)(Checkbox);
const CustomIcon = withStyles(iconStyles)(Icon);

const GetDictionary = () => {
  const data = useStaticQuery(graphql`
    {
      allSanityDictionary(
        filter: { key: { in: ["signup_widget_thank_you_text"] } }
      ) {
        nodes {
          value
          key
        }
      }
    }
  `);

  return data.allSanityDictionary.nodes;
};

const useStyles = makeStyles((theme) => ({
  signUpContainer: {
    background: '#3C465F',
    borderRadius: "8px",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row-reverse",
    },
  },
  signUpImageContainer: {
    [theme.breakpoints.up("md")]: {
      padding: "29px 24px 29px 24px",
      display: "none",
    },
    [theme.breakpoints.up("lg")]: {
      display: "flex",
    },
  },
  signUpImage: {
    height: "100%",
    width: "100%",
    borderRadius: "8px 8px 0 0",
    objectFit: "cover",
    [theme.breakpoints.up("md")]: {
      borderRadius: "8px",
    },
  },
  textButtonInputContainer: {
    padding: "1rem",
    color: "#ffffff",
    [theme.breakpoints.up("md")]: {
      padding: "1rem",
    },
    [theme.breakpoints.up("lg")]: {
      padding: "1.5rem 7px 1.5rem 1.5rem",
    },

  },
  textButtonInputContainerNoImg: {
    padding: "1rem",
    color: "#ffffff",
  },
  titleAndParaHolder: {
    marginBottom: "1.5rem",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
      marginBottom: "1rem",
    },
    [theme.breakpoints.up("lg")]: {
      marginBottom: "1.5rem",
    },
    '& p, h1, h2, h3, h4, h5, label, span, li, ul': {
      color: '#FFF !important'
    }
  },
  inputField: {
    width: "100%",
    height: "52px",
    background: "#FFFFFF",
    boxShadow: "inset 0px 2px 2px -1px rgba(74, 74, 104, 0.1)",
    borderRadius: "8px",
    "& > div": {
      fontSize: "14px",
      height: "100%",
      "&::before": {
        borderBottom: "none !important",
      },
    },
    "& input": {
      paddingLeft: "1rem",
      paddingRight: "1rem",
    },
  },
  buttonContainer: {
    display: "flex",
    marginTop: "1rem",
    [theme.breakpoints.up("md")]: {
      marginTop: 0,
      paddingLeft: 8,
    },
  },
  buttonContainerError: {
    marginTop: "1rem",
    [theme.breakpoints.down("sm")]: {
      marginTop: "1rem",
      paddingTop: "0",
    },
    [theme.breakpoints.up("md")]: {
      marginTop: 0,
      paddingLeft: 8,
    },
  },
  submitButton: {
    background: "#FF0F5F",
    color: "white",
    textTransform: "uppercase",
    width: "100%",
    height: "52px",
    borderRadius: "8px",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.04)",
    "&:hover": {
      background: "#FF0F5F",
      color: "white",
    },
    "&:focus": {
      background: "#FF0F5F",
      color: "white",
    },
    "&:active": {
      background: "#FF0F5F",
      color: "white",
    },
    [theme.breakpoints.up("md")]: {
      paddingLeft: "1rem",
      paddingRight: "1rem",
    },
    [theme.breakpoints.up("lg")]: {
      paddingLeft: "1.5rem",
      maxWidth: "fit-content",
    },
  },
  submitIcon: {
    paddingLeft: "9px",

  },
  inputError: {
    boxShadow: "inset 0px 2px 2px -1px rgba(74, 74, 104, 0.1)",
    border: "#FF0F5F 1px solid",
    borderRadius: "8px",
    color: "white",
  },
  subscribedContainer: {
    padding: "1rem",
  },
  paragraphText: {
    color: "white",
  },
  errorText: {
    position: "relative",
    bottom: "16px",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    display: "inline-flex",
    paddingTop: "8px",
    width: "100%",
    color: "white",
    marginTop: '16px'
  },
  errorIcon: {
    height: "16px",
    width: "16px",
  },
  bodyText: {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "white",
  },
  holderForParaOnly: {
    paddingTop: "4px",
  },
  checkboxSpan: {
    display: 'inline-block',
    width: 'calc(100% - 47px)',
    cursor: 'pointer'
  },
  marketingConsentContainer: {
    marginTop: '1em'
  },
  titleLabel: {
    color: 'white !important'
  },
  checkboxContainer:{
    display: "flex",
  } ,
}));

const EmailSignupWidget = ({
  title,
  image,
  paragraphText,
  buttonText,
  textboxPlaceholder,
  subscribedCallback,
  brazeCustomAttributes,
}) => {
  const [state, setState] = useState({
    username: "",
    errors: {},
    formIsValid: false,
    isSubmitted: false,
    isToggleOn: true,
    marketingConsent: false
  });

  const classes = useStyles();

  const holderEl = useRef(null);

  const initialiseThankYou = async () => {
    const result = await getSignupThankYouText();
    setState((state) => ({ ...state, thankYouText: result[0].value }));
  };

  const [logGA, setLogGA] = useState(false);

  useEffect(() => {
    (async () => {
      if (logGA) emailCaptureSubmissionLogging()
    })();
  }, [logGA]);

  useEffect(() => {
    initialiseThankYou();
  }, []);

  useEffect(() => {
    if (state.isSubmitted && window.dataLayer) {
      window.dataLayer.push({ event: "subscribe_form_submitted" });
    }
  }, [state]);

  const handleUsername = (event) => {
    let errors = {};
    let formIsValid = true;
    let field = event.target.value;

    setState((state) => ({
      ...state,
      username: event.target.value,
      errors: errors,
      formIsValid: formIsValid,
    }));
  };

  const submitted = (event) => {
    let formIsValid = state.formIsValid;
    let userName = state.username;
    let errors = {};

    if (typeof state.formIsValid == "undefined") {
      formIsValid = false;
      errors["empty"] = "Field is empty";
      setState((state) => ({ ...state, errors: errors }));
    }

    const emailRegex = /^[\w\-.+]+@([\w-]+\.)+[\w-]{2,4}$/g;

    if (typeof state.formIsValid !== "undefined") {
      let lastAtPos = userName.lastIndexOf("@");
      let lastDotPos = userName.lastIndexOf(".");

      if (!userName.match(emailRegex)) {
        formIsValid = false;
        errors["email"] = "Email is invalid";
        setState((state) => ({ ...state, errors: errors }));
      }
    }

    event.preventDefault();

    if (formIsValid) {
      //signupToBlog(state.username);

      //window.signup(state.username, brazeSubscriptionRefGate, state.marketingConsent, brazeCustomAttributes);

      if (brazeCustomAttributes && brazeCustomAttributes[0]?.customAttributeKey){
        localStorage.setItem('custom_attr', btoa(brazeCustomAttributes[0].customAttributeKey + "|" + brazeCustomAttributes[0].customAttributeValue));
      }
      setLogGA(true)
      const hash = window.location.hash
      localStorage.setItem("hash", hash)
      localStorage.setItem("genMkt", state.marketingConsent)
      window.location.href =
        "/login?returnUrl=" +
        encodeURIComponent(`${window.location.pathname}${hash ? hash : ""}`) +
        "&usr=" +
        btoa(state.username);

      return null;

      //subscribedCallback();

      //setState((state) => ({
      //  ...state,
      //  isToggleOn: !state.isToggleOn,
      //  isSubmitted: true,
      //}));
    } else {
      holderEl.current.className =
        holderEl.current.className + ` ${classes.inputError}`;
      //console.log("formIsValid", formIsValid);
    }
  };

  const getSignupThankYouText = async function () {
    var params = {};

    var query =
      "*[_type == 'dictionary'][key match ['signup_widget_thank_you_text']]";

    return createClient()
      .fetch(query, params)
      .then((response) => response)
      .then((responseJson) => {
        return responseJson;
      });
  };

  const handleChange = (event) => {
    setState({ ...state, marketingConsent: event.target.checked });
  };

  return (
    <Grid
      container
      className={classes.signUpContainer}
      alignItems={state.isToggleOn ? null : "center"}
    >
      <>
        {image && image.asset &&
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={5}
            className={classes.signUpImageContainer}
          >
            {image && image.asset && (
              <SanityImage asset={image?.asset} className={classes.signUpImage} />
            )}
          </Grid>
        }
        <Grid
          container
          xs={12}
          sm={12}
          md={12}
          lg={image && image.asset ? 7 : 12}
          className={image && image.asset ? classes.textButtonInputContainer : classes.textButtonInputContainerNoImg}
        >
          <Grid container className={classes.titleAndParaHolder}>
            <Grid item>
              <Typography variant="h4">
                {state.isToggleOn ? title : state.thankYouText}
              </Typography>
            </Grid>
            <Grid item className={classes.holderForParaOnly}>
              <Typography variant="body-2" className={classes.bodyText}>
                {state.isToggleOn
                  ? paragraphText
                  : "Subscription confirmation sent to the specified e-mail You’ll start receiving free tips and resources soon."}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={8} lg={7}>
            {state.isToggleOn ? (
              <TextField
                ref={holderEl}
                id="emailField"
                className={classes.inputField}
                placeholder="Enter your email address..."
                value={state.username}
                onChange={handleUsername}
              />
            ) : null}
          </Grid>

          <Hidden smDown>
            {state.isToggleOn && (
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                lg={5}
                className={
                  state.errors && Object.keys(state.errors).length > 0
                    ? classes.buttonContainerError
                    : classes.buttonContainer
                }
              >
                <Button className={classes.submitButton} onClick={submitted}>
                  {buttonText}
                  <img src={emailIcon} className={classes.submitIcon} />
                </Button>
              </Grid>
            )}
          </Hidden>

          <Hidden smDown>
            {state.errors && Object.keys(state.errors).length > 0 ? (
              <span className={classes.errorText}>
                <img
                  className={classes.errorIcon}
                  src={errorIcon}
                  alt="error"
                />
                &nbsp;Please enter a valid email address{" "}
              </span>
            ) : null}
          </Hidden>
          <Hidden mdUp>
            {state.errors && Object.keys(state.errors).length > 0 ? (
              <span className={classes.errorText}>
                <img
                  className={classes.errorIcon}
                  src={errorIcon}
                  alt="error"
                />
                &nbsp;Please enter a valid email address{" "}
              </span>
            ) : null}
          </Hidden>
          <Grid item xs={12} className={classes.marketingConsentContainer}>
            {state.isToggleOn ? (
              <label className={classes.checkboxContainer}>
                <ReusableCheckbox checked={state.marketingConsent} handleChange={handleChange} />
                <span className={classes.checkboxSpan}>
                  I would like to hear from you about products, events, general
                  marketing and other things from Boring Money – including
                  personalised content and ads - but please try not to make them
                  as boring as everything else in finance!
                </span>
              </label>
            ) : null}
          </Grid>
          <Hidden mdUp>
            {state.isToggleOn && (
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                lg={5}
                className={
                  state.errors && Object.keys(state.errors).length > 0
                    ? classes.buttonContainerError
                    : classes.buttonContainer
                }
              >
                <Button className={classes.submitButton} onClick={submitted}>
                  {buttonText}
                  <img src={emailIcon} className={classes.submitIcon} />
                </Button>
              </Grid>
            )}
          </Hidden>
        </Grid>
      </>
    </Grid>
  );
};

export default EmailSignupWidget;
